import angular from 'angular';

import tszReportParam from './tsz-report-param';

const tszReportParamModule = angular.module('tsz.components.tszReportParam', [])
  .component('tszReportParam', tszReportParam);

export default tszReportParamModule;



// WEBPACK FOOTER //
// ./src/components/tsz-report-param/tsz-report-param.module.js